var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 21,
    viewBox: "0 0 29 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6897 2.77747C12.6897 1.00291 10.5504 0.107328 9.28617 1.35264L1.44645 9.07518C0.651144 9.85859 0.651144 11.1414 1.44645 11.9248L9.28617 19.6474C10.5504 20.8927 12.6897 19.9971 12.6897 18.2225V15.625C12.6897 14.5204 13.5851 13.625 14.6897 13.625H27C28.1046 13.625 29 12.7296 29 11.625V9.375C29 8.27043 28.1046 7.375 27 7.375H14.6897C13.5851 7.375 12.6897 6.47957 12.6897 5.375V2.77747Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.dd925b9fd01c29cb46efb8dfeb5598ee.svg";
export { ForwardRef as ReactComponent };